(function() {
  'use strict';

  angular
    .module('admin.print.service', [])
    .factory('PrintService', PrintService);

  /** @ngInject */
  function PrintService($http, $q, API) {

    function list(collectibleId, edition, printNumber){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/prints/' + collectibleId + '/' + edition + '/' + printNumber + '/history?format=json')
        .success(defered.resolve);

      return defered.promise;
    }

    return{
        list: list
    };

  }

})();
